import _defineProperty from "C:\\Users\\krish\\Downloads\\trex-main\\trex-main\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { useCallback as t } from "react";
import e from "zustand";
import { redux as o } from "zustand/middleware";
var r = function r(t, e) {
    if (!t.includes(e)) throw new Error("'".concat(e, "' not found. It must be provided in initialState as a property key."));
  },
  n = function n(o) {
    var n = e(function () {
        return o;
      }),
      s = Object.keys(o),
      a = function a(t, e) {
        "production" !== process.env.NODE_ENV && r(s, t), n.setState(function (o) {
          return _defineProperty({}, t, (r = o[t], n = e, "function" == typeof n ? n(r) : n));
          var r, n;
        });
      };
    return {
      useGlobalState: function useGlobalState(e) {
        "production" !== process.env.NODE_ENV && r(s, e);
        var o = t(function (t) {
          return t[e];
        }, [e]);
        return [n(o), t(function (t) {
          return a(e, t);
        }, [e])];
      },
      getGlobalState: function getGlobalState(t) {
        return "production" !== process.env.NODE_ENV && r(s, t), n.getState()[t];
      },
      setGlobalState: a
    };
  },
  s = function s(r) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r(void 0, {
      type: void 0
    });
    var a = arguments.length > 2 ? arguments[2] : undefined;
    if (a) return a(s)(r, n);
    var i = e(o(r, n)),
      u = Object.keys(n),
      c = function c(e) {
        "production" !== process.env.NODE_ENV && function (t, e) {
          if (!t.includes(e)) throw new Error("'".concat(e, "' not found. It must be provided in initialState as a property key."));
        }(u, e);
        var o = t(function (t) {
          return t[e];
        }, [e]);
        return i(o);
      };
    return {
      useStoreState: c,
      useGlobalState: function useGlobalState(e) {
        return "production" !== process.env.NODE_ENV && console.warn("[DEPRECATED] useStoreState instead"), [c(e), t(function (t) {
          i.setState(function (o) {
            return _defineProperty({}, e, (r = o[e], n = t, "function" == typeof n ? n(r) : n));
            var r, n;
          });
        }, [e])];
      },
      getState: i.getState,
      dispatch: i.dispatch
    };
  };
export { n as createGlobalState, s as createStore };